
import { Vue, Component } from 'vue-property-decorator';
import Card from './Card.vue';
import { dataCard } from '@/utils/dataCard';

@Component({
    components: { Card }
})
export default class GridCard extends Vue {
    dataCard = dataCard;
}
